<template>
    <div>
        <!-- <div class="filter__section mb-2" v-if="listDataSubject && listDataSubject.length > 0">
            <div class="filter__title secondary-color-txt font-sanpro-semibold">Bộ môn</div>
            <div class="filter__form display-flex justify-content-between filter_option_menu">
                <div class="filter__form display-flex justify-content-between">
                    <div class="radio-custom item">

                        <input type="radio" name="subjectId" :value="0" :checked="subjectId == 0"
                            @change="handleChangeSubjectId" />

                        <label class="color-form secondary-color-txt font-sanpro-light">Tất cả</label>
                    </div>
                </div>
                <div class="radio-custom item" v-for="(item, index) of listDataSubject" :key="index">

                    <input type="radio" name="subjectId" :value="item.subjectId" :checked="subjectId == item.subjectId"
                        @change="handleChangeSubjectId" />

                    <label class="color-form secondary-color-txt font-sanpro-light">{{ item.name }}</label>
                </div>
            </div>
        </div> -->
        <div class="filter__section">
            <div class="row">
                <div v-if="!isHideFilterClass" class="col-md-6">
                    <!-- <div class="filter__title secondary-color-txt font-sanpro-semibold">Lớp</div> -->
                    <b-form-select @change="handleChangeClassId" v-model="classId" :options="listDataClass">
                        <!-- <option value=0>Tất cả</option> -->
                    </b-form-select>
                </div>
                <div class="col-md-6">
                    <!-- <div class="filter__title secondary-color-txt font-sanpro-semibold">Bộ môn</div> -->
                    <b-form-select @change="handleChangeSubjectId" v-model="subjectId" :options="listDataSubject">
                        <!-- <option value=0>Tất cả</option> -->
                    </b-form-select>
                </div>
            </div>
        </div>
        <!-- <div class="filter__section__form text-align-left">
            <a @click="onRefresh" href="javascript:;" class="primary-color font-sanpro-semibold mr-3">Làm mới</a>
            <a @click="handleOnFilter" href="javascript:;"
                class="btn btn-main border-rd-20 btn-submit font-sanpro-semibold margin-left-10 min-width-100">Lọc</a>
        </div> -->
    </div>

</template>


<script>
import { getAllTypeFilter, getAllClassFilter } from './../_api/'
export default {
    name: 'FilterCollapse',
    props: {
        isHideFilterClass: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            subjectId: 0,
            classId: 0,
            listDataSubject: [{ value: 0, text: "Môn học - Tất cả" },], // danh sách môn
            listDataClass: [{ value: 0, text: "Khối - Tất cả" },]
        }
    },
    watch: {
        'classId': 'getTypesFilter'
    },
    mounted() {
        //this.getTypesFilter()
        this.GetAllClass()
        // this.getTypesFilter()
    },
    methods: {
        handleChangeSubjectId(e) {
            //this.subjectId = e.target.value
            this.handleOnFilter()
        },
        handleChangeClassId(e) {
            //this.classId = e.target.value
            this.handleOnFilter()
        },
        onRefresh() {
            this.subjectId = 0;
            this.classId = 0
            this.handleOnFilter()
        },
        handleOnFilter() {
            let filter = {
                subjectId: this.subjectId,
                classId: this.classId
            }
            this.$emit('handleOnFilterCollapse', filter)
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = [{ value: 0, text: "Môn học - Tất cả" },]
            this.subjectId = 0
            getAllTypeFilter({ classId: this.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            getAllClassFilter({}).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.text-align-right {
    text-align: right;
}

.filter__section__form {
    margin-top: 20px;

    .margin-left-10 {
        margin-left: 10px;
    }

    .min-width-100 {
        min-width: 100px;
    }
}

.filter_option_menu {
    flex-wrap: wrap;

    >* {
        //width: 33.33%;
    }
}
</style>